import { Controller } from "@hotwired/stimulus";


/**
 * Stimulus controller for survey respondent filtering and display toggling.
 * Handles segment/status filtering and toggling of answered question display.
 *
 * @class SurveyRespondentController
 * @extends Controller
 */
export default class extends Controller {
  /**
   * Stimulus targets for DOM elements.
   * @type {string[]}
   */
  static targets = [
    'questionAnsweredHeader',
    'questionAnsweredCount',
    'segmentSource',
    'statusSource',
    'filterable'
  ]
  /**
   * Values for lower-case search terms.
   * @type {{lowerCaseSegmentTerm: String, lowerCaseStatusTerm: String}}
   */
  static values = {
    lowerCaseSegmentTerm: {
      type: String,
      default: ''
    },
    lowerCaseStatusTerm: {
      type: String,
      default: ''
    }
  }


  /**
   * Toggles the display of the answered questions header and count.
   * Updates the button text and value accordingly.
   * @param {Event} e
   */
  toggleDisplay(e) {
    $(this.questionAnsweredHeaderTarget).toggleClass('d-none');
    $(this.questionAnsweredCountTargets).toggleClass('d-none');
    if (e.currentTarget.value == 'true') {
      $(e.currentTarget).val(false).text("Hide Q's Answered");
    } else {
      $(e.currentTarget).val(true).text("Show Q's Answered");
    }
  }


  /**
   * Filters the respondent list by segment and status terms.
   * Hides rows that do not match the current filter terms.
   * @param {Event} event
   */
  filter(event) {
    this.lowerCaseSegmentTerm = this.segmentSourceTarget.value.toLowerCase();
    if (this.hasStatusSourceTarget) {
      this.lowerCaseStatusTerm = this.statusSourceTarget.value.toLowerCase();
    }
    this.filterableTargets.forEach((el, i) => {
      let filterableKey = el.getAttribute("data-survey-respondent-key").toLowerCase();
      // TODO: The i > 25 check is unclear; clarify or remove if not needed.
      if (i > 25) {
        // No-op: unclear why this is here; possibly for debugging or future batching
      }
      if (this.hasStatusSourceTarget) {
        el.classList.toggle("d-none", !(filterableKey.includes(this.lowerCaseSegmentTerm) && filterableKey.includes(this.lowerCaseStatusTerm)));
      } else {
        el.classList.toggle("d-none", !filterableKey.includes(this.lowerCaseSegmentTerm));
      }
    });
  }
}
